import React from "react";

export default function Component(props) {
  return (
    <div className="2xl:mx-24 xl:mx-16 lg:mx-6 lg:my-10 my-4 mx-4">
      {props.children}
    </div>
  );
}
